module.exports = __webpack_public_path__ + "img/设计图片示例1.3cdbc5c5.png";